import { compareNullable } from "./other/compareNullable";

export const uppercaseFirstLetter = (string: string): string =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const isString = (variable: unknown): variable is string =>
  typeof variable === "string" || variable instanceof String;

export const compareStrings = (a: null | string, b: null | string): number => {
  return compareNullable<string>(a, b, (a, b) => a.localeCompare(b));
};

export const filterCaseInsensitive = (
  value: null | string,
  filter: string,
): boolean =>
  value !== null && value.toLowerCase().indexOf(filter.toLowerCase()) !== -1;

export const trimNullableString = (value?: null | string): null | string =>
  typeof value === "string" ? value.trim() : null;
